import { Component, Input } from '@angular/core';

export interface DetailRow { label: string; value: any; }

@Component({
  selector: 'payarc-detail-card',
  template: `
    <div class="pa-detail" [class.pa-detail--flat]="flat">
      <h3 class="pa-detail__title" *ngIf="title">{{ title }}</h3>
      <dl class="pa-detail__list">
        <div class="pa-detail__row" *ngFor="let r of rows">
          <dt>{{ r.label }}</dt><dd>{{ r.value }}</dd>
        </div>
      </dl>
    </div>`,
  styleUrls: ['./payarc-detail-card.component.css'],
  standalone: false
})
export class PayarcDetailCardComponent {
  @Input() title?: string;
  @Input() flat = false;
  @Input() rows: DetailRow[] = [];
}
